var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    style: _vm.style,
    on: {
      touchstart: function ($event) {
        $event.stopPropagation()
      },
      touchmove: function ($event) {
        $event.stopPropagation()
      },
      touchend: function ($event) {
        $event.stopPropagation()
      },
      touchcancel: function ($event) {
        $event.stopPropagation()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }